import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useNavigation } from '../../utilities/NavigationContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EndPoint = process.env.REACT_APP_API_ENDPOINT;

class Register extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '', password: '', passwordConfirm: '',
      firstName: '', lastName: '', userType: '', role: '',
      q1: '', q1Detail: '',     // yes/no + text
      q2Detail: '',             // text only
      q3: '', q3Detail: '',     // yes/no + text
      passwordMatch: true
    };
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'password' || name === 'passwordConfirm') {
      const match = name === 'password'
        ? value === this.state.passwordConfirm
        : value === this.state.password;
      this.setState({ [name]: value, passwordMatch: match });
    } else this.setState({ [name]: value });
  };

  buildCombinedComment = () => {
    const { q1, q1Detail, q2Detail, q3, q3Detail } = this.state;
    return [
      `1) Are you presently overseeing patients with multiple chronic conditions?  Answer: ${q1 || 'not answered'}`,
      q1Detail && `   Details: ${q1Detail.trim()}`,
      `2) Care-plan strategies used:`,
      q2Detail && `   ${q2Detail.trim()}`,
      `3) Do you think live care plan is important?  Answer: ${q3 || 'not answered'}`,
      q3Detail && `   Details: ${q3Detail.trim()}`
    ].filter(Boolean).join('\n');
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { password, passwordConfirm, firstName, lastName, email, userType, q1, q3 } = this.state;

    if (password !== passwordConfirm)
      return toast.error('Passwords do not match!');

    if (!q1 || !q3)
      return toast.error('Please answer Yes/No for questions 1 and 3.');

    const comment = this.buildCombinedComment();
    if (!comment.trim()) return toast.error('Please add some comments.');

    try {
      const res = await axios.post(`${EndPoint}/user`, {
        firstName, lastName, email, password, passwordConfirm, userType,
        role: 'user', comment
      });
      toast.success(res.data.message);
      this.props.navigate('/login');
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Error registering');
    }
  };


  render() {
    return (
      <div>
        <div className='absolute -mt-56 -ml-[900px] bg-gradient-to-b from-sky-700 via-sky-800 to-sky-900 w-[1500px] h-[1500px] rounded-xl rotate-20 opacity-30 z-40 xs:hidden sm:hidden'></div>
        <div className='absolute -mt-64 -ml-[800px] bg-gradient-to-b from-sky-700 via-sky-800 to-sky-900 w-[1500px] h-[1500px] rounded-xl rotate-20 opacity-30 z-40 xs:hidden sm:hidden'></div>
        <div className='flex flex-col items-center h-full bg-gradient-to-b from-sky-900 to-sky-800 py-16'>
          <form onSubmit={this.handleSubmit} className='p-10 z-50' >
            <h2 className='text-3xl my-4 text-sky-300 font-semibold text-center'>Registration</h2>
            <h3 className='text-2xl mt=10- text-sky-200 text-center'>Streaming Chronic Care Management for</h3>
            <h3 className='text-2xl mb-10 text-sky-200 text-center'>Better and Safer Outcomes</h3>
            <div className='w-[600px] p-0.5 rounded-xl bg-gradient-to-r from-sky-600 to-sky-800 xs:w-[500px] sm:w-[500px]'>
              <div className='flex flex-col p-10 gap-6 w-auto rounded-xl bg-sky-900'>

                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  value={this.state.firstName}
                  onChange={this.handleInputChange}
                  className='rounded border border-sky-700 bg-sky-800 p-4 text-sky-100 text-sm placeholder:text-sky-400 focus:border-sky-600'
                />
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  value={this.state.lastName}
                  onChange={this.handleInputChange}
                  className='rounded border border-sky-700 bg-sky-800 p-4 text-sky-100 text-sm placeholder:text-sky-400 focus:border-sky-600'
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={this.state.email}
                  onChange={this.handleInputChange}
                  className='rounded border border-sky-700 bg-sky-800 p-4 text-sky-100 text-sm placeholder:text-sky-400 focus:border-sky-600'
                />
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={this.state.password}
                  onChange={this.handleInputChange}
                  className='rounded border border-sky-700 bg-sky-800 p-4 text-sky-100 text-sm placeholder:text-sky-400 focus:border-sky-600'
                />
                <input
                  type="password"
                  name="passwordConfirm"
                  placeholder="Confirm Password"
                  value={this.state.passwordConfirm}
                  onChange={this.handleInputChange}
                  className='rounded border border-sky-700 bg-sky-800 p-4 text-sky-100 text-sm placeholder:text-sky-400 focus:border-sky-600'
                />

                <select
                  name="userType"
                  value={this.state.userType}
                  onChange={this.handleInputChange}
                  required
                  className='rounded border border-sky-700 bg-sky-800 p-4 text-sky-400 text-sm placeholder:text-sky-400 focus:border-sky-600'
                >
                  <option value="" disabled>Select your Role</option>
                  <option value="GP">GP</option>
                  <option value="Specialist">Specialist</option>
                  <option value="Allied Health">Allied Health</option>
                  <option value="Others">Others</option>
                </select>

                {/* Q1 */}
                <div className="bg-sky-950/30 p-4 rounded-lg border border-sky-800 mb-4">
                    <p className="text-sky-200 text-sm mb-3">
                    1) Are you presently overseeing patients with multiple chronic conditions and complex consultations?
                    </p>
                    <div className="flex gap-6 mb-3 text-sky-200 text-sm">
                    <label className="flex items-center gap-2">
                        <input type="radio" name="q1" value="yes"
                            checked={this.state.q1 === 'yes'}
                            onChange={this.handleInputChange}/> Yes
                    </label>
                    <label className="flex items-center gap-2">
                        <input type="radio" name="q1" value="no"
                            checked={this.state.q1 === 'no'}
                            onChange={this.handleInputChange}/> No
                    </label>
                    </div>
                    <textarea name="q1Detail" value={this.state.q1Detail}
                            onChange={this.handleInputChange}
                            placeholder="Brief details or examples..."
                            className="w-full rounded border border-sky-700 bg-sky-800 p-3 text-sky-100 text-sm h-20 resize-none"/>
                </div>

                {/* Q2 – textarea only */}
                <div className="bg-sky-950/30 p-4 rounded-lg border border-sky-800 mb-4">
                    <p className="text-sky-200 text-sm mb-3">
                    2) What kind of care plan strategies do you use (e.g., update every consultation, separate notes, none)?
                    </p>
                    <textarea name="q2Detail" value={this.state.q2Detail}
                            onChange={this.handleInputChange}
                            placeholder="Describe your current strategy..."
                            className="w-full rounded border border-sky-700 bg-sky-800 p-3 text-sky-100 text-sm h-20 resize-none"/>
                </div>

                {/* Q3 */}
                <div className="bg-sky-950/30 p-4 rounded-lg border border-sky-800 mb-6">
                    <p className="text-sky-200 text-sm mb-3">
                    3) Do you think a live / always-up-to-date care plan is important? If yes, why?
                    </p>
                    <div className="flex gap-6 mb-3 text-sky-200 text-sm">
                    <label className="flex items-center gap-2">
                        <input type="radio" name="q3" value="yes"
                            checked={this.state.q3 === 'yes'}
                            onChange={this.handleInputChange}/> Yes
                    </label>
                    <label className="flex items-center gap-2">
                        <input type="radio" name="q3" value="no"
                            checked={this.state.q3 === 'no'}
                            onChange={this.handleInputChange}/> No
                    </label>
                    </div>
                    <textarea name="q3Detail" value={this.state.q3Detail}
                            onChange={this.handleInputChange}
                            placeholder="Why or why not?"
                            className="w-full rounded border border-sky-700 bg-sky-800 p-3 text-sky-100 text-sm h-20 resize-none"/>
                </div>

                <div className='text-center'>
                  <button type="submit" className='bg-sky-600 hover:bg-sky-700 rounded-lg shadow-lg w-40 text-white px-4 py-2'>Create Account</button>
                </div>
                <Link to="/" className='text-sky-300 text-center'>Already have an account? Login here.</Link>
              </div>
            </div>
          </form>
        </div>

        <ToastContainer />
      </div>
    );
  }
}

// Higher-order component to consume the NavigationContext
const RegisterWithNavigation = (props) => {
  const navigate = useNavigation(); // Use the useNavigation hook here
  return <Register {...props} navigate={navigate} />;
};

export default RegisterWithNavigation;
